<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-output/Announcements' }">公告管理</el-breadcrumb-item>
            <el-breadcrumb-item>公告详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="公告标题：">
              <el-col :span="10">
                <el-input v-model="form.title" placeholder="请输入标题" clearable></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="发布范围：">
              <el-row>
                <el-col :span="24">
                  <el-radio-group v-model="form.board_id">
                    <el-radio label="-1">发布到所有大屏</el-radio>
                    <el-radio label="1">发布到特定大屏</el-radio>
                    <el-radio label="2">发布到特定区域</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row v-if="form.board_id == 1">
                <el-col :span="9" style="margin-top: 15px">
                  <el-input v-model="keywordQuery" placeholder="输入大屏ID,多个用英文逗号隔开" clearable></el-input>
                </el-col>
              </el-row>

              <el-row v-if="form.board_id == 2">
                <el-col :span="9" style="margin-top: 15px">
                  <el-input v-model="keywordQuery" placeholder="美洲/加拿大" clearable></el-input>
                </el-col>
                <el-col :span="6" style="margin-left:10px;margin-top: 15px">
                  <template>
                    <el-button type="primary" @click="queryData()">选择</el-button>
                    <el-button type="primary" @click="queryData()">添加</el-button>
                  </template>
                </el-col>
              </el-row>
              
            </el-form-item>

            <el-form-item label="生效时间段：">
              <el-row>
                <el-col :span="10">
                  <el-date-picker
                    clearable
                    v-model="form.active_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @focus="timeFn">
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="公告内容：">
              <el-row>
                <el-col :span="9">
                  <el-input type="textarea" rows="8" v-model="form.content" resize="none"></el-input>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="短信群发：">
              <el-row>
                <el-col :span="4">
                  <el-switch
                    v-model="smsTurn"
                    active-color="#13ce66"
                    active-text="发送公告到用户组"
                    @change="switchFn"
                    >
                  </el-switch>
                </el-col>
                <el-col :span="5" v-if="smsTurn">
                  <el-select style="width: 100%" v-model="form.sms_group_id" multiple collapse-tags clearable  placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="9">
                  <span style="font-size: 12px; color: gray">*将在生效时间段的起始时刻发送，且仅发送“公告内容”</span>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="$route.query.id > 0? editSubmit():onSubmit()">提交</el-button>
              <el-button @click="cancelFn">取消</el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  data() {
    return {
      tableData: [],
      rowData: {},
      loading: true,
      form: {
        board_id: "-1",
        sms_group_id: "-1",
        area_id: "-1"
      },
      smsTurn: false,
      keywordQuery: "",
      options: [],
    };
  },
  created() {
    this.userList()
    if(this.$route.query.id) {
      this.editInfo()
    }
  },
  methods: {
    // 新增提交
    onSubmit() {
      this.form.active_time_begin = new Date(this.form.active_time[0]).getTime() / 1000
      this.form.active_time_end = new Date(this.form.active_time[1]).getTime() / 1000
      delete this.form.active_time
      api.noticeAdd(this.form)
      .then(res => {
        if(res.error_code == 0) {
          this.$message.success("提交成功！！");
          this.$router.push({
            name: "Announcements"
          });
        }
        
      })
      .catch(err => {
        // this.$message(err);
      });
    },

    // 用户组列表
    userList() {
      api.userList()
      .then(res => {
        this.options = res.list
      })
      .catch(err => {
        
      });
    },

    // 时间初始化
    timeFn() {
      delete this.form.active_time
    },
    // switch开关
    switchFn() {
      if(this.smsTurn == false) {
        this.smsTurn = false
        this.form.sms_group_id = "-1"
      }else{
        console.log(this.smsTurn)
        this.smsTurn = true
      }
    },

    // 编辑提交
    editSubmit() {
      this.form.active_time_begin = new Date(this.form.active_time[0]).getTime() / 1000
      this.form.active_time_end = new Date(this.form.active_time[1]).getTime() / 1000
      delete this.form.active_time
      console.log(this.form)
      api.editInit(this.form)
      .then(res => {
       if(res.error_code == 0) {
          this.$message.success("修改成功！！");
          this.$router.push({
            name: "Announcements"
          });
        }
      })
      .catch(err => {
        
      });
    },

    // 编辑详情
    editInfo() {
      let datas = {
        id: this.$route.query.id
      }
      api.editInfo(datas)
      .then(res => {
        this.form = res.info
        this.form.active_time = []
        this.form.active_time[0] = this.timestampToTime(res.info.active_time_begin)
        this.form.active_time[1] = this.timestampToTime(res.info.active_time_end)
        if(res.info.sms_group_id == "-1") {
          this.smsTurn = false
        }else {
          this.smsTurn = true
        }
      })
      .catch(err => {
      });
    },

    // 取消
    cancelFn() {
      this.$confirm('取消页面将不会保存，是否确定？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          name: "Announcements"
        });
      }).catch(() => {
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
</style>